import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import ProgressBar from '@ramonak/react-progress-bar';
import styles from './index.module.scss';

interface IUserProps {
  userName: string;
  avatar: string;
  progress: number;
}

const UserInfo: React.FC<IUserProps> = ({ userName, avatar, progress }) => {
  return (
    <>
      <div className={styles.userInfo}>
        <div className={styles.avatar}>
          <Avatar
            style={{ height: '56px', width: '56px' }}
            src={avatar}
            alt={userName}
          />
        </div>
        <div className={styles.info}>
          <span className="deep-gray-heading bold">{userName}</span>
          <div>
            <ProgressBar
              borderRadius="10px"
              height="4px"
              bgcolor="#F3B50D"
              isLabelVisible={false}
              completed={progress}
            />
            <span>{progress}%</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserInfo;
